import React from "react"
import { useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { Toggle } from "shared/ui/input/boolean/toggle/Toggle"

import { useVariantKey } from "entities/products/model/useVariantKey"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"
import { useProductPositionFormPriceContext } from "../../contexts/ProductPositionFormPriceContext"

export const ProductPositionSpecialPriceGroupInput = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoadingSpecialPriceGroups } = useProductPositionFormLoadingContext()
  const { hideSpecialPriceGroupToggle } = useProductPositionFormPriceContext()
  const { hidePrice } = formOptions || {}

  const variantKey = useWatch({ name: "productPosition.variantKey" }) as
    | string
    | null
  const { productType } = useVariantKey(variantKey ?? null)

  if (hidePrice || isReadonly || hideSpecialPriceGroupToggle) return null

  return (
    <Toggle.Root
      inputID="product-position-form__is-special-price-group"
      name="isSpecialPriceGroup"
      label={t("Project.SpecialPriceGroup")}
      className="product-position-form__is-special-price-group"
      readonly={isReadonly}
      loading={isLoadingSpecialPriceGroups}
      disabled={isDisabled}
    >
      <div className="toggle-control toggle-control--horizontal">
        <Toggle.Input data-testid="product-position-form__is-special-price-group__input" />{" "}
        <Toggle.Label />
        <Toggle.InfoTip
          content={
            productType
              ? t("Project.SpecialPriceGroupInfo", { productType })
              : null
          }
          label={t("Form.ShowInfoFor", {
            field: t("Project.SpecialPriceGroup")
          })}
        />
        <Toggle.Readonly />
      </div>
      <Toggle.ErrorMessage />
    </Toggle.Root>
  )
})
